import React from "react";
import { Alert, Text } from "@thecb/components";
import { AI_PRIMARY, BETA_ORANGE_TINT } from "@/constants/colors";

// Laid out like PaymentsBetaBanner. No flag check: the beta page is already
// gated.
const bannerStyles = `
  background-color: ${BETA_ORANGE_TINT};
  min-height: 0;
  margin-bottom: 1.625rem;
  > div > div {
    align-items: center;
  }
  /* An inline svg leaves a baseline gap under the icon, which throws off the centering. */
  svg {
    display: block;
  }
  /* The icon's shape; the mask's own <use> has no fill and must stay white. */
  svg use[fill] {
    fill: ${AI_PRIMARY};
  }
`;

const PaymentsBetaAnnouncement = () => (
  <Alert
    variant="announcement"
    showQuitLink={false}
    noBorder
    padding="0.875rem 1.375rem"
    iconPadding="0"
    innerContentPadding="0 0 0 0.75rem"
    extraStyles={bannerStyles}
    textOverride={
      <Text variant="p" color={AI_PRIMARY} dataQa="Payments beta announcement">
        <Text variant="p" color={AI_PRIMARY} weight="700">
          The new Payments tab is new and coming soon
        </Text>
        , but you can start using it now. Some changes may happen before it
        officially goes live.
      </Text>
    }
  />
);

export default PaymentsBetaAnnouncement;
